export const sortListValue = [
  { id: 'byWorkExperience', name: 'За стажем роботи' },
  { id: 'fromAToZ', name: 'Від А до Я' },
  { id: 'fromZToA', name: 'Від Я до А' },
  { id: 'byRating', name: 'За рейтингом' },
];
